module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3LjU0IDE2LjMzIj4KICA8dGl0bGU+YXJyb3ctbGVmdDwvdGl0bGU+CiAgPHBvbHlsaW5lIHBvaW50cz0iNy4yNSAxNi4wOSAwLjQ5IDguMTcgNy4yNSAwLjI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMyMTE3NTUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIwLjc1Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-left.svg
// module id = JREx
// module chunks = 0